export const evidenceFeedStyles = {
  containerStyle: {
    overflowY: "auto",
    overflowX: "hidden",
    padding: "24px 6px 0 24px",
    margin: "0",
    maxWidth: "none",
  },
  itemFeedContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(244px, 1fr))",
    gridGap: "16px",
  },
};

export const unitPlanFeedStyles = {
  ...evidenceFeedStyles,
  feedContainerStyle: {
    height: "100%",
  },
  searchFilterContainerStyle: {
    marginBottom: "0",
  },
};

export const assessmentFeedStyles = {
  stepContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    padding: "24px 0 20px",
    margin: "0",
    maxWidth: "none",
  },
  feedContainer: {
    paddingRight: "6px",
  },
  itemFeedContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(328px, 1fr))",
    gridGap: "16px",
  },
};

export const assignmentFeedStyles = {
  container: {
    overflowY: "auto",
    overflowX: "hidden",
    padding: "24px 6px 0 24px",
    margin: "0",
    maxWidth: "none",
  },
  feedContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(328px, 1fr))",
    gridGap: "16px",
  },
};
